import { Dispatch } from 'redux';
import { api, dev } from '../config/api';
import { GetState } from "../config/store";
import { axiosClient } from '../config/axios';
import { catch401 } from '../helpers/actions';
import {
  brandPublicationPostRequest,
  brandPublicationPostSuccess,
  brandPublicationPostFailure,
  brandPublicationCleanPost,
  brandPublicationUpdateRequest,
  brandPublicationUpdateSuccess,
  brandPublicationUpdateFailure,
  brandPublicationCleanUpdate,
  brandPublicationImagesPostRequest,
  brandPublicationImagesPostSuccess,
  brandPublicationImagesPostFailure
} from '../reducers/brandPublication';

// Acción para crear brand publication
export const createBrandPublication = (publicationData: any) => (dispatch: Dispatch, getState: GetState) => 
  _createBrandPublication(publicationData, dispatch, getState);

const _createBrandPublication = async (publicationData: any, dispatch: Dispatch, getState: GetState) => {
  try {
    dispatch(brandPublicationPostRequest());

    const body = JSON.stringify(publicationData);
    const response = await axiosClient.post(`${api.publications}/brand-publications`, body);

    dispatch(brandPublicationPostSuccess(response?.data?.data));

    return response?.data?.data;
  } catch (error: any) {
    const errorResponse = error?.response?.data?.error;
    console.log('Brand publication error:', errorResponse?.code);
    catch401(errorResponse?.code, dispatch);
    
    dispatch(brandPublicationPostFailure({
      code: errorResponse?.code,
      message: errorResponse?.message
    }));
    throw error;
  }
};

// Acción para actualizar brand publication
export const updateBrandPublication = (publicationId: string, publicationData: any) => (dispatch: Dispatch, getState: GetState) => 
  _updateBrandPublication(publicationId, publicationData, dispatch, getState);

const _updateBrandPublication = async (publicationId: string, publicationData: any, dispatch: Dispatch, getState: GetState) => {
  try {
    dispatch(brandPublicationUpdateRequest());

    const body = JSON.stringify(publicationData);
    const response = await axiosClient.patch(`${api.publications}/brand-publications/${publicationId}`, body);

    dispatch(brandPublicationUpdateSuccess(response?.data?.data));

    return response?.data?.data;
  } catch (error: any) {
    const errorResponse = error?.response?.data?.error;
    console.log('Brand publication update error:', errorResponse?.code);
    catch401(errorResponse?.code, dispatch);
    
    dispatch(brandPublicationUpdateFailure({
      code: errorResponse?.code,
      message: errorResponse?.message
    }));
    throw error;
  }
};

// Acción para subir imágenes con brand=true
export const postBrandPublicationImages = (formData: any, id?: number) => (dispatch: Dispatch, getState: GetState) => 
  _postBrandPublicationImages(formData, id, dispatch, getState);

const _postBrandPublicationImages = async (formData: any, id: number | undefined, dispatch: Dispatch, getState: GetState) => {
  try {
    dispatch(brandPublicationImagesPostRequest());
    
    const token = getState().auth.token;
    const endpoint = dev 
      ? `https://api-test.linze.cl/api/v1/publications/files?brand=true` 
      : `https://api.linze.cl/api/v1/publications/files?brand=true`;

    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      body: formData
    });

    const json = await response.json();
    if (!json.success) throw json;

    dispatch(brandPublicationImagesPostSuccess({
      id: json.data.file.id,
      path: json.data.file.path,
      original: json.data.file.original
    }));

    return json.data.file;
  } catch (error: any) {
    console.log('Brand publication images error:', error?.error?.code);
    catch401(error?.error?.code, dispatch);
    
    dispatch(brandPublicationImagesPostFailure(error));
    throw error;
  }
};

// Acción para limpiar el estado de creación
export const cleanBrandPublicationPost = () => (dispatch: Dispatch) => 
  dispatch(brandPublicationCleanPost());

// Acción para limpiar el estado de actualización
export const cleanBrandPublicationUpdate = () => (dispatch: Dispatch) => 
  dispatch(brandPublicationCleanUpdate());
